// extracted by mini-css-extract-plugin
module.exports = {"modal-portal":"_2Sn47c","modal":"_2wQ56C","modal-dialog":"_2_e-g9","visible":"_1h3i_z","scrollable":"_1NKc2O","close-btn":"_1KAjNd"};